import { EEthereumNetworkId } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';
import config from 'config';

import { ErrorMessage, isEstimateFee } from 'modules/common';
import {
  ContractsManager,
  convertToHex,
  isWeb3KeyWriteProvider,
} from 'modules/core';
import { api, cacheTags } from 'modules/store';

export const {
  useWithdrawMutation,
  endpoints: { withdraw },
} = api.injectEndpoints({
  endpoints: build => ({
    withdraw: build.mutation<
      null,
      {
        chainId: EEthereumNetworkId | null;
        amount: BigNumber;
        accountAddress: string;
      }
    >({
      queryFn: async ({ chainId, amount, accountAddress }) => {
        if (!chainId) {
          throw new Error(ErrorMessage.ChainIdIsNotDefined);
        }

        const networkConfig = config[chainId];
        if (!networkConfig) {
          throw new Error(ErrorMessage.ConfigIsNotDefined);
        }

        const sdk = await ContractsManager.getInstance({ chainId });
        const contract = await sdk.getRegistryContract();
        const provider = await sdk.getProvider();

        if (!isWeb3KeyWriteProvider(provider)) {
          throw new Error(ErrorMessage.ProviderIsNotValid);
        }

        const data = contract.methods
          .withdrawUserFunds(convertToHex(amount), accountAddress)
          .encodeABI();

        const { receiptPromise } = await provider.sendTransactionAsync(
          accountAddress,
          networkConfig.contracts.registry,
          {
            data,
            estimate: true,
            estimateFee: isEstimateFee(chainId),
          },
        );

        await receiptPromise;

        return { data: null };
      },

      invalidatesTags: [cacheTags.balance],
    }),
  }),
});
